import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/common/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CalendarPage from './pages/CalendarPage';
import CreateReservationPage from './pages/CreateReservationPage';
import EditReservationPage from './pages/EditReservationPage';
import PriceComparePage from './pages/PriceComparePage';
import PasswordChangePage from './pages/PasswordChangePage';
import BlacklistPage from './pages/BlacklistPage';
import RoomManagementPage from './pages/RoomManagementPage';
import LoadingSpinner from './components/common/LoadingSpinner';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" state={{ from: location }} replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="reservations/new" element={<CreateReservationPage />} />
        <Route path="reservations/:id" element={<EditReservationPage />} />
        <Route path="rooms" element={<RoomManagementPage />} />
        <Route path="prices" element={<PriceComparePage />} />
        <Route path="passwords" element={<PasswordChangePage />} />
        <Route path="blacklist" element={<BlacklistPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
